import { createContext, ReactNode, useContext } from 'react';

export const HamburgerMenuContext = createContext<(e?: ReactNode) => void>(() => {});

export const useHamburgerMenuContext = () => useContext(HamburgerMenuContext);
